
export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = Object.assign({}, options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.searchFormModal();
    this.mainVisualSlider();
  }

  /**
   * カスタム関数
   */

  // headerのフォーム
  searchFormModal() {
    const triggerbtnName = ".js-header-searchform-open";
    const contentName = ".js-header-searchform-content";
    // const closebtnName = ".js-header-searchform-close";
    const triggerBtns = document.querySelectorAll(triggerbtnName);
    // const closeBtns = document.querySelectorAll(closebtnName);

    triggerBtns.forEach((triggerBtn) => {
      triggerBtn.addEventListener('click', function (e) {
        //トリガーボタンを押したときの動作
        if(document.body.classList.contains('is-search-modal-open')){
          document.body.classList.remove("is-search-modal-open");
          triggerBtns.forEach((button) => button.classList.remove("is-active"));
        }else{
          document.body.classList.add("is-search-modal-open");
          triggerBtns.forEach((button) => button.classList.add("is-active"));
        }
      });
    });
    document.addEventListener('click', function(e) {
      //bodyに.is-search-modal-openがついているときに、
      //検索フォーム本体でもトリガーボタンでも無い要素が押されたら
      if(!e.target.closest(contentName) && !e.target.closest(triggerbtnName)){
        if(document.body.classList.contains('is-search-modal-open')){
          //bodyの.is-search-modal-openと、トリガーボタンの.is-activeを外す
          document.body.classList.remove("is-search-modal-open");
          triggerBtns.forEach((button) => button.classList.remove("is-active"));
        }
      }
    });
  }



  /**
   * メインビジュアルのクロスフェードスライダー
   *
   * Swiper を使わない理由：
   *   MV はドラッグ・ページネーション・breakpoints をどれも使っておらず、
   *   実質「一定間隔でクロスフェードするだけ」のためライブラリの利点がない。
   *   加えて Swiper v14 の loop はスライドを DOM 上で並べ替えるため、
   *   1枚ごとのズーム（Ken Burns）を CSS アニメーションで持たせると再生が巻き戻る。
   *
   * .js-main-visual
   *   .c-main-visual__list
   *     .c-main-visual__image.is-active
   *     .c-main-visual__image
   *
   * 表示中のスライドにだけ .is-active が付く。フェードとズームは CSS 側で行う。
   * ※ interval は main-visual.scss の $mv-slide-interval と必ず揃えること
   */
  mainVisualSlider() {
    const targetName = ".js-main-visual";
    const slideName = ".c-main-visual__image";
    const activeClass = "is-active";
    const interval = 6000; // 1枚あたりの表示時間（ミリ秒 / ズームにかける時間と同じ）
    const minSlides = 2;   // これ未満の枚数なら切り替えない

    const target = document.querySelector(targetName);
    if (!target) return;

    const slides = Array.from(target.querySelectorAll(slideName));
    if (slides.length < minSlides) return;

    // HTML 側で1枚目に .is-active が付いている前提。無ければ先頭を表示中にする
    let current = slides.findIndex((slide) => slide.classList.contains(activeClass));
    if (current < 0) {
      current = 0;
      slides[0].classList.add(activeClass);
    }

    let timerId = null;

    // 次のスライドへ
    const next = () => {
      slides[current].classList.remove(activeClass);
      current = (current + 1) % slides.length;
      slides[current].classList.add(activeClass);
    };

    const start = () => {
      if (timerId) return;
      timerId = setInterval(next, interval);
    };

    const stop = () => {
      if (!timerId) return;
      clearInterval(timerId);
      timerId = null;
    };

    start();

    // 非表示のタブや画面外では動かさない（無駄な再描画を止める）
    document.addEventListener("visibilitychange", () => {
      document.hidden ? stop() : start();
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.isIntersecting && !document.hidden ? start() : stop();
        });
      });
      observer.observe(target);
    }
  }


  // 複製して作業
  mycode() {

  }


}

